import { Core, Partner, ProfileTypes, Site, User } from "..";

export interface Header extends User.Header {
    partner?: Partner.Header;
    siteAssignments: {site: Site.Header, role: Site.PartnerUserRole}[];
    shown: boolean;
    isPendingApproval: boolean;
    isPendingPortalInvite: boolean;
}

export enum AttachmentType {
    STATE_ID, WAIVER_FORM, SIGNATURE
}

export interface PartnerUser extends Header {
    email: string;
    profile: Profile;
    attachments: {[key in AttachmentType]: Core.Document};
    preferences: {
        notifications: User.NotificationPreferences;
    };
    assignedAmbassadors: string[];
}

export interface Profile {
    firstName: string;
    middleName?: string;
    lastName: string;
    jobTitle: string;
    phone: string;
    address: ProfileTypes.Address;
}